var _defs, _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriveViewGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 227.83,
    y1: 302.82,
    x2: 377.81,
    y2: 302.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.83,
    y: 51.83,
    width: 326.34,
    height: 326.34,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.83,
    y: 57.83,
    width: 314.34,
    height: 314.34,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m63.83,201.8h125.98c6.62,0,12-5.38,12-12V63.83c0-6.62-5.38-12-12-12H63.83c-6.62,0-12,5.38-12,12v125.97c0,6.62,5.38,12,12,12Zm113.98-125.97v101.97h-101.98v-101.97h101.98Z",
    fill: "#f7f7f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m240.19,51.83c-6.62,0-12,5.38-12,12v125.97c0,6.62,5.38,12,12,12h125.98c6.62,0,12-5.38,12-12V63.83c0-6.62-5.38-12-12-12h-125.98Zm12,125.97v-101.97h101.98v101.97h-101.98Z",
    fill: "#f7f7f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m51.83,366.17c0,6.62,5.38,12,12,12h125.98c6.62,0,12-5.38,12-12v-125.97c0-6.62-5.38-12-12-12H63.83c-6.62,0-12,5.38-12,12v125.97Zm125.98-113.97v101.97h-101.98v-101.97h101.98Z",
    fill: "#f7f7f7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m365.81,227.83h-125.98c-6.62,0-12,5.38-12,12v125.97c0,6.62,5.38,12,12,12h125.98c6.62,0,12-5.38,12-12v-125.97c0-6.62-5.38-12-12-12Zm-113.98,125.97v-101.97h101.98v101.97h-101.98Z",
    fill: "url(#ds)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveViewGrid);
export default __webpack_public_path__ + "static/media/drive_view_grid.e9752cc04103bd8e938a80fee72b7f89.svg";
export { ForwardRef as ReactComponent };